export const types = {
    SET_MAIN_MENU_TITLE: "SET_MAIN_MENU_TITLE",
}

export function setMainMenuTitle(payload: string) {
    return {type: types.SET_MAIN_MENU_TITLE, payload};

}
